import { Component } from '@angular/core';

@Component({
    selector: 'app-running-tasks',
    templateUrl: './running-tasks.component.html',
    styleUrl: './running-tasks.component.css',
    standalone: false
})
export class RunningTasksComponent {

}
